<template>
  <div class="lay" :style="style"><slot /></div>
</template>

<script>
export default {
  props: {
    style: {
      type: Object
    }
  }
}
</script>

<style lang="scss" scoped>
.lay {
  height: 100%;
  background-color: #FFF;
  overflow: auto;
}
</style>
